export default "__VITE_ASSET__o34PBQI2__"